import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

// The chat socket now delivers what is addressed to a user to every connection
// that user opened with a ticket, and ignores this frame. It is still sent
// because the socket that predates that change delivers through it alone, and
// this frontend ships before it is replaced. Drop it once lixani-dynamodb-api's
// 8-WebSockets/chat is deployed to every environment.
export const connectPrivateWebsocketThunk = createAsyncThunk(
  'chat/connectPrivateWebsocket',
  async ({ chatWebsocketRef, userId }, { getState }) => {
    const socketValidObject = {
      newUserConnection: {
        id: v4(),
        userId,
        isActive: true,
      },
    };
    chatWebsocketRef.current.send(JSON.stringify(socketValidObject));
  }
);
